import React from 'react';

const TennisGameCard = ({ match }) => {
  if (!match) return null;

  const {
    home_team,
    away_team,
    set_scores,
    status,
    match_state,
    category,
    is_live
  } = match;

  // Handles both scraper array-of-objects and DB string arrays
  const parseSetScores = () => {
    if (!set_scores || set_scores.length === 0) return [];
    if (typeof set_scores[0] === 'object') return set_scores;
    
    return set_scores.map((scoreStr, idx) => {
      const [home, away] = scoreStr.split('-');
      return {
        set: idx + 1,
        home: home?.trim() || '0',
        away: away?.trim() || '0'
      };
    });
  };

  const parsedSetScores = parseSetScores();

  // Helper to safely render scores like "7(5)" into 7⁵
  const renderTiebreaker = (score) => {
    if (!score) return null;
    
    const scoreStr = String(score);
    
    // If the score contains a parenthesis, extract the tiebreaker
    if (scoreStr.includes('_')) {
      const [mainScore, tiebreaker] = scoreStr.split('_');
      return (
        <span style={{ position: 'relative' }}>
          {mainScore}
          <sup style={{ 
            fontSize: '10px', 
            position: 'absolute',
            top: '-4px',
            marginLeft: '1px', 
            fontWeight: 'normal',
            color: 'var(--text-gray)' // Optional: makes the tiebreaker slightly dimmer
          }}>
            {tiebreaker.replace(')', '')}
          </sup>
        </span>
      );
    }
    
    // If it's just a normal score like "6", return it as is
    return scoreStr;
  };

  // Reusable sub-component for the player row
  const PlayerRow = ({ player }) => {
    const showRank = player.rank && player.rank !== '-' && player.rank !== '0';
    
    return (
      <div className="team-row">
        {/* Use UI Avatars for tennis players if no official headshot exists, make them circular */}
        <img 
          src={player.logo || `https://ui-avatars.com/api/?name=${player.name}&background=random&color=fff`} 
          alt={player.name} 
          className="team-logo" 
          style={{ borderRadius: '50%' }} 
        />
        <div className="team-info">
          <div className="team-meta">
            {showRank ? (
              <>
                <span className="team-rank">Seed {player.rank}</span>
              </>
            ) : (
            //   <span className="team-rank">ATP</span>
            <></>
            )}
          </div>
          <div className="team-name">{player.name}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="game-card">
      
      {/* LEFT SIDE: Players */}
      <div className="teams-column">
        <PlayerRow player={home_team} />
        <PlayerRow player={away_team} />
      </div>

      {/* RIGHT SIDE: Sets, Score, and Status */}
      <div className="game-details" style={{ flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
        
        {/* Tennis Sets & Match Score */}
        {parsedSetScores.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', textAlign: 'right', fontWeight: '700' }}>
            
            {/* Top Row: Home Player Scores (Heights matched exactly to .team-row to stay perfectly parallel) */}
            <div style={{ display: 'flex', gap: '12px', color: 'var(--text-gray)', fontSize: '14px', alignItems: 'center', height: '36px', justifyContent: 'flex-end' }}>
            {parsedSetScores.map((s, i) => (
            <span key={`home-set-${i}`} style={{ width: '16px', textAlign: 'center' }}>
                {renderTiebreaker(s.home)}
            </span>
            ))}
              {/* Total Sets Won */}
              <span style={{ color: 'var(--text-white)', fontSize: '16px', marginLeft: '8px' }}>
                {home_team.score}
              </span>
            </div>

            {/* Bottom Row: Away Player Scores */}
            <div style={{ display: 'flex', gap: '12px', color: 'var(--text-gray)', fontSize: '14px', alignItems: 'center', height: '36px', justifyContent: 'flex-end' }}>
                {parsedSetScores.map((s, i) => (
    <span key={`away-set-${i}`} style={{ width: '16px', textAlign: 'center' }}>
        {renderTiebreaker(s.away)}
    </span>
))}
              {/* Total Sets Won */}
              <span style={{ color: 'var(--text-white)', fontSize: '16px', marginLeft: '8px' }}>
                {away_team.score}
              </span>
            </div>

          </div>
        )}

        {/* Status / Category Column (Matches the soccer 'time-box' location) */}
        <div className="time-box" style={{ minWidth: '60px', textAlign: 'right', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <span className="game-time" style={{ color: is_live ? '#ef4444' : 'var(--text-white)' }}>
            {status || (match_state === 'finished' ? 'Final' : 'Live')}
          </span>
          <div className="comment-count" style={{ fontSize: '11px', marginTop: '4px', color: 'var(--text-dark-gray)' }}>
            {category || "Singles"}
          </div>
        </div>

      </div>
    </div>
  );
};

export default TennisGameCard;